import { cloneDeep, isEqual } from 'lodash'

import Vue from '@/setup'
import { DateTimeHelper, LogHelper, PersonHelper } from '@/helpers'

const { $backend } = Vue.prototype
const INIT_CONTRACT = 'INIT_CONTRACT'
const ADD_PERSON = 'ADD_PERSON'

export default {
  namespaced: true,

  state() {
    return {
      address: {},
      basketId: null,
      contractStartDate: null,
      language: null,
      masterTreaty: null,
      persons: [],
    }
  },

  getters: {
    getContractData: state => {
      return {
        address: state.address,
        contractStartDate: state.contractStartDate,
      }
    },

    getPerson: state => personId => {
      const person = cloneDeep(state.persons.find(person => person.personId === personId))
      person.age = DateTimeHelper.getAge(person.personData.dateOfBirth)
      return person
    },

    getPersons: (state, getters, _rootState, rootGetters) => {
      return PersonHelper.addTabInfoToPersons(cloneDeep(state.persons))
        .map(person => {
          person.total = getters.getTotalPriceOfPerson(person.personId)
          person.selectedProducts = rootGetters['products/getSelectedProductsByCategory'](person.products.products)
          return person
        })
    },

    getProduct: (_state, getters) => (personId, productId) => getters.getPerson(personId).products.products[productId],

    getProductPrice: (_state, getters) => (personId, productId) =>
      getters.getProduct(personId, productId).prices.find(p => !!p.selected),

    getSelectedProductsOfPerson: (_state, getters, _rootState, rootGetters) => personId => {
      const products = rootGetters['products/getProducts'] || {}
      const person = getters.getPerson(personId)

      return Object.keys(person.products.products)
        .map(productId => Object.assign({ id: productId }, products[productId], person.products.products[productId]))
        .filter(product => product.selected)
        .map(product => {
          product.price = product.prices.find(p => !!p.selected)
          delete product.prices
          return product
        })
    },

    getTotalPriceOfPerson: (_state, getters) => personId => {
      let total = 0
      getters.getSelectedProductsOfPerson(personId).forEach(product => {
        total += product.price.price
      })
      return total
    },
  },

  mutations: {
    [INIT_CONTRACT](state, contract) {
      contract.persons[0].personId = contract.persons[0].contractNumber
      for (const key in contract) {
        if (!isEqual(contract[key], state[key])) {
          Vue.set(state, key, contract[key])
        }
      }
      LogHelper.info([`%c${INIT_CONTRACT}`, 'color: lightgreen', state])
    },

    [ADD_PERSON](state, person) {
        person.personId = person.contractNumber
        state.persons.push(person)
        LogHelper.info([`%c${ADD_PERSON}`, 'color: lightgreen', state])

    }
  },

  actions: {
    async setContract({commit}, basket) {
      const { basketId, language, jwToken, persons } = basket
      let initContract = false
      for (let i = 0; i < persons.length; i++) {
        if (!persons[i].contractNumber) continue

        const contractNumber = persons[i].contractNumber
        const personContract = await $backend.ovp.getContract({basketId, contractNumber, language, jwToken})
        if (!initContract) {
          commit(INIT_CONTRACT, personContract)
          initContract = true
        } else {
          commit(ADD_PERSON, personContract.persons[0])
        }
      }
    }
  },
}
